// Auto-generated for /pages/capital-equipment during Magento → Shopify migration.
// Loaded with <script defer> so DOM is ready before this runs.

(function() {
    'use strict';

    var CATEGORIES = [
        {
            name: 'SMT Pick & Place',
            description: 'Automated component placement systems',
            url: '/panasonic-smt-systems-2',
            icon: 'pickplace'
        },
        {
            name: 'SMT Printers',
            description: 'Solder paste stencil printers',
            url: '/panasonic-smt-systems-2',
            icon: 'printer'
        },
        {
            name: 'Reflow Ovens',
            description: 'Multi-zone convection reflow soldering',
            url: '/reflow-ovens',
            icon: 'reflow'
        },
        {
            name: 'Wave & Selective Soldering',
            description: 'Through-hole & mixed technology',
            url: '/sasinno-selective-soldering-systems',
            icon: 'wave'
        },
        {
            name: 'AOI & SPI',
            description: 'Automated optical & solder paste inspection',
            url: '/aoi-landing',
            icon: 'aoi'
        },
        {
            name: 'X-Ray Inspection',
            description: 'BGA & hidden joint inspection',
            url: '/x-ray-inspection',
            icon: 'xray'
        },
        {
            name: 'Thermal Profiling',
            description: 'Process monitoring & optimization',
            url: '/thermal-profiling',
            icon: 'thermal'
        },
        {
            name: 'Conveyors & Stackers',
            description: 'PCB handling & line integration',
            url: '//conveyors-board-stackers',
            icon: 'conveyor'
        },
        {
            name: 'Stencil Cleaners',
            description: 'Automated stencil cleaning systems',
            url: '/stencil-cleaners',
            icon: 'stencil'
        }
    ];

    var FEATURED = [
        {
            category: 'tagarno',
            tag: 'ESD',
            title: 'Static Shielding Bags',
            description: 'Static shielding bags are multi-layered bags with a metallic layer that creates a Faraday cage, offering superior protection for sensitive electronics (PCBs, components) from electrostatic discharge (ESD) damage',
            url: '/esd/esd-packaging/esd-bags.html'
        },
        {
            category: 'aoi',
            tag: 'Soldering',
            title: 'Soldering & Rework Stations',
            description: 'Shop for soldering irons, tips, accessories and rework',
            url: '/soldering-stations-rework/soldering.html'
        },
        {
            category: 'ecd',
            tag: 'Chemistry',
            title: 'Cleaners & Aerosols',
            description: 'Cleaners and aerosols are essential consumables for electronics manufacturing, providing the solvents, sprays, and tools needed to maintain clean assemblies and equipment.',
            url: '/cleaners-aerosols.html'
        }
    ];

    var BRANDS = [
        'Panasonic',
        'TAGARNO',
        'AOI Systems',
        'ASC International',
        'ECD',
        'SASinno'
    ];

    var ICONS = {
        pickplace: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"></rect><path d="M12 2v4"></path><path d="M12 18v4"></path><circle cx="8" cy="12" r="2"></circle><circle cx="16" cy="12" r="2"></circle></svg>',
        printer: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="10" rx="1"></rect><path d="M7 8V4h10v4"></path><path d="M7 14h10"></path><path d="M7 18h10"></path></svg>',
        aoi: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><path d="M11 8v6"></path><path d="M8 11h6"></path></svg>',
        reflow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 16s1.5-2 4-2 4 2 4 2"></path><path d="M12 12c0-3 2-5 2-8"></path><path d="M8 12c0-2.5 1-4.5 1.5-6.5"></path><path d="M16 12c0-2.5-1-4.5-1.5-6.5"></path><rect x="4" y="16" width="16" height="6" rx="2"></rect></svg>',
        thermal: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"></path><line x1="12" y1="14" x2="12" y2="14.01"></line></svg>',
        conveyor: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="22" height="4" rx="1"></rect><circle cx="5" cy="14" r="3"></circle><circle cx="19" cy="14" r="3"></circle><line x1="8" y1="14" x2="16" y2="14"></line><line x1="5" y1="10" x2="5" y2="11"></line><line x1="19" y1="10" x2="19" y2="11"></line></svg>',
        wave: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12c.6.5 1.2 1 2.5 1C7 13 7 11 9.5 11c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path><path d="M2 17c.6.5 1.2 1 2.5 1C7 18 7 16 9.5 16c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"></path><rect x="4" y="4" width="16" height="4" rx="1"></rect></svg>',
        xray: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"></rect><circle cx="12" cy="12" r="4"></circle><path d="M3 12h4"></path><path d="M17 12h4"></path><path d="M12 3v4"></path><path d="M12 17v4"></path></svg>',
        stencil: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="1"></rect><path d="M8 10v4"></path><path d="M12 10v4"></path><path d="M16 10v4"></path><path d="M3 10h18"></path><path d="M3 14h18"></path></svg>'
    };

    function createCategoryCard(category) {
        var card = document.createElement('a');
        card.href = category.url;
        card.className = 'category-card';
        card.innerHTML = '<div class="category-icon">' + ICONS[category.icon] + '</div>' +
            '<h3>' + category.name + '</h3>' +
            '<p>' + category.description + '</p>' +
            '<span class="category-link">View Equipment <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span>';
        return card;
    }

    function createFeaturedCard(item) {
        var card = document.createElement('a');
        card.href = item.url;
        card.className = 'featured-card';
        card.dataset.category = item.category;
        card.innerHTML = '<div class="featured-bg"></div>' +
            '<div class="featured-content">' +
            '<span class="featured-tag">' + item.tag + '</span>' +
            '<h3>' + item.title + '</h3>' +
            '<p>' + item.description + '</p>' +
            '</div>';
        return card;
    }

    function createBrandTag(brand) {
        // Brand tags on the Capital Equipment page can be added freely without
        // a guarantee that a matching Shopify collection exists, so we route
        // through the built-in vendor-filter URL — it always resolves to a
        // valid product listing regardless of curated-collection coverage.
        var tag = document.createElement('a');
        tag.href = '/collections/vendors?q=' + encodeURIComponent(brand);
        tag.className = 'brand-tag';
        tag.textContent = brand;
        return tag;
    }

    function renderCategories() {
        var grid = document.getElementById('categoriesGrid');
        if (!grid) return;
        var fragment = document.createDocumentFragment();
        CATEGORIES.forEach(function(cat) {
            fragment.appendChild(createCategoryCard(cat));
        });
        grid.appendChild(fragment);
    }

    function renderFeatured() {
        var grid = document.getElementById('featuredGrid');
        if (!grid) return;
        var fragment = document.createDocumentFragment();
        FEATURED.forEach(function(item) {
            fragment.appendChild(createFeaturedCard(item));
        });
        grid.appendChild(fragment);
    }

    function renderBrands() {
        var list = document.getElementById('brandList');
        if (!list) return;
        var fragment = document.createDocumentFragment();
        BRANDS.forEach(function(brand) {
            fragment.appendChild(createBrandTag(brand));
        });
        list.appendChild(fragment);
    }

    function init() {
        renderCategories();
        renderFeatured();
        renderBrands();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();